import processorsUrl from './processors.worklet.ts?worker&url';

const loaded = new WeakMap<BaseAudioContext, Promise<void>>();

/**
 * Loads the engine's AudioWorklet module into `context` once. Shared by the
 * engine and the worklet-backed filters so either can be used first.
 */
export function loadWorklets(context: BaseAudioContext): Promise<void> {
  let promise = loaded.get(context);
  if (!promise) {
    promise = context.audioWorklet.addModule(processorsUrl);
    loaded.set(context, promise);
    // A failed load (e.g. network error in dev) may be retried by the next caller.
    promise.catch(() => {
      if (loaded.get(context) === promise) loaded.delete(context);
    });
  }
  return promise;
}
